import React from 'react'
import{Carousel} from 'react-responsive-carousel'
import img1 from "../Assets/1.jpg"
import img2 from "../Assets/2.jpg"
import img3 from "../Assets/3.jpg"
import img4 from "../Assets/4.jpg"

import 'react-responsive-carousel/lib/styles/carousel.min.css'
const Services = () => {
  return  <div >
    <Carousel infiniteLoop autoPlay showStatus={false} showArrows={false} interval={1000} showThumbs={false}>
    
    <div>
        <img src={img1} alt="item1"/>
        <p className='legend'>HomeLoan</p>
    </div>
    <div>
        <img src={img2} alt="item2"/>
        <p className='legend'>BusinessLoan</p>
    </div>
    <div>
        <img src={img3} alt="item1"/>
        <p className='legend'>MortgageLoan</p>
    </div>
    <div>
        <img src={img4} alt="item1"/>
        <p className='legend'>CarLoan</p>
    </div>

</Carousel>
    </div>
  
}

export default Services